import { userService } from '../../../_services';
import Vue from 'vue';
import { setUserContext } from '../../../plugins/sentry.js';
import { extractUserProfile } from '@/auth/authProfile';
import { appPerfMark, appPerfMeasure } from '@/utils/appBootstrapPerfLog.js';

const state = {
  userProfile: null,
  loginError: null,
  isAuthTokenExpired: null,
  roles: {
    ADMIN: 'ADMIN',
    USER: 'USER'
  }
};

const mutations = {
  currentUser(state, userProfile) {
    appPerfMark('user.currentUser:vueSet:start');
    Vue.set(state, 'userProfile', userProfile);
    appPerfMeasure('user.currentUser:vueSet', 'user.currentUser:vueSet:start');

    appPerfMark('user.currentUser:sentry:start');
    if (userProfile) {
      setUserContext({
        id: userProfile.id || userProfile.seq,
        username: userProfile.userId,
        role: userProfile.userRole,
        email: userProfile.email || null
      });
    } else {
      setUserContext(null);
    }
    appPerfMeasure('user.currentUser:sentry', 'user.currentUser:sentry:start');
  },
  loginError(state, err) {
    state.loginError = err;
  },
  isAuthTokenExpired(state, isExpired) {
    state.isAuthTokenExpired = isExpired;
  }
};

const actions = {
  setCurrentUser({ commit }, userProfile) {
    commit('currentUser', userProfile);
  },

  login({ commit }, credentials) {
    return userService.login({ username: credentials.username, password: credentials.password }).then(
      (userProfile) => {
        //로그인 성공한 경우
        // // window.localStorage.setItem("auth-token", res.data.token);
        commit('currentUser', userProfile);
        return true;
      },
      (error) => {
        //authToken없는 경우 + 서버에러 발생한 경우 error:string
        console.log('login  error,', error);
        commit('loginError', error);
        return false;
      }
    );
  },

  logout({ commit }) {
    commit('currentUser', null);
  },
  /**
		 * return true :authToken 유효
		 * return false : authToken 에러 혹은 만료
		 */
  validateAuthToken({ commit }) {
    return userService.getMyProfile().then(
      (response) => {
        const profile = extractUserProfile(response);
        if (!profile) {
          commit('isAuthTokenExpired', true);
          return false;
        }
        commit('currentUser', profile);
        commit('isAuthTokenExpired', false);
        return true;
      },
      (error) => {
        console.log('validate auth token error,', error);
        commit('loginError', error);
        commit('isAuthTokenExpired', true);
        return false;
      }
    );
  },

  clearLoginError({ commit }) {
    commit('loginError', null);
  }
};

const getters = {
  isLogined(state) {
    return !!state.userProfile;
  },
  getUserProfile(state) {
    return state.userProfile;
  },
  getLoginError(state) {
    return state.loginError;
  },
  isAuthTokenExpired(state) {
    return state.isAuthTokenExpired;
  },
  hasRole: (state) => (role) => {
    if (!state.userProfile) return false;
    return state.userProfile?.userRole.includes(role);
  },
  isAdmin(state) {
    return state.userProfile?.userRole === state.roles.ADMIN;
  },
  isUser(state) {
    return state.userProfile?.userRole === state.roles.USER;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
